import { useSelector } from '@xstate/react'
import clsx from 'clsx'
import { Ref } from 'preact/compat'

import { AnimatedNumber } from './AnimatedNumber'
import {
  annualConsumptionSelector,
  useNaturalPowerContext,
  useNaturalPowerRatio,
} from './NaturalPowerCalculatorProvider'
import { StepSlider } from './StepSlider'

interface MiniInputsProps {
  scrollTarget: Ref<HTMLDivElement>
}

export function MiniInputs({ scrollTarget }: MiniInputsProps) {
  const services = useNaturalPowerContext()
  const naturalPowerRatio = useNaturalPowerRatio()
  const annualConsumption = useSelector(services.costInput, annualConsumptionSelector)

  const handleClick = () => {
    scrollTarget.current?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div
      className={clsx(
        'grid grid-cols-1 pt-8 auto-rows-fr transition-colors divide-y divide-white text-base text-white',
        naturalPowerRatio > 0 ? 'bg-navy' : 'bg-error',
      )}>
      <div className="flex items-center justify-between h-12 pr-4">
        <div className="w-3/4 ml-2 max-w-lg">
          <StepSlider className="h-6">
            <StepSlider.Track className="h-6 px-3 -top-0.5" />
            <StepSlider.Thumb className="w-8 h-6" name="Mini" />
          </StepSlider>
        </div>
        <span>
          <strong className="font-normal">
            <AnimatedNumber value={naturalPowerRatio * 100} transform={(x) => Math.round(x)} />
          </strong>
          %
        </span>
      </div>
      <button className="flex items-center justify-between h-12 px-4 appearance-none" onClick={handleClick}>
        <span className="font-normal">Annual consumption (kWh)</span>
        <span className="font-normal">{annualConsumption.toLocaleString()}</span>
      </button>
    </div>
  )
}
